import { computed, inject, Injectable } from '@angular/core';
import { BaseStore, ModalService } from '@malirang/front-share';
import { GuideModal, GuideModalProps } from '../modals/guide/guide.modal';

type State = {
  path: string;
};

@Injectable({ providedIn: 'any' })
export class GuardStore extends BaseStore<State> {
  readonly modalService = inject(ModalService);

  // 구독, 마이페이지, 고객지원, 비밀번호 변경
  authWhiteList = ['/subscription', '/my-page', '/customer', '/change'];

  /**
   * 허용되는 path 목록
   * path가 목록에 포함되어 있으면 visible을 true로 설정
   */
  whiteList = [
    '/content',
    '/center/form',
    '/center/find',
    ...this.authWhiteList,
  ];

  /**
   * 현재 path
   */
  path = computed(() => this.state()?.path || '');

  constructor() {
    super({
      path: '',
    });
  }

  setPath(path: string) {
    this.updateState({ path });
  }

  /**
   * 센터 찾기 가이드 모달 열기
   */
  openGuideModal() {
    this.modalService.create<GuideModalProps>(GuideModal, {
      componentProps: {
        type: 'FIND_CENTER',
      },
    });
  }
}
